import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link, useStaticQuery, graphql } from 'gatsby';
import { COLORS, BREAKPOINTS } from '../styles/constants';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  toolbar: {
    marginTop: BREAKPOINTS.topbar,
  },
  drawerPaper: {
    zIndex: 10,
    width: drawerWidth,
    backgroundColor: '#ddd',
    borderRight: 0,
  },
  list: {
    backgroundColor: 'white',
    padding: 0,
  },
  listItem: {
    padding: 12,
  },
  selected: {
    border: 'solid',
  },
}));

const Sidebar = ({ drawerToggle, open }) => {
  const { allMarkdownRemark } = useStaticQuery(
    graphql`
      query {
        allMarkdownRemark(sort: { fields: [frontmatter___title] }) {
          edges {
            node {
              id
              html
              frontmatter {
                title
                path
              }
            }
          }
        }
      }
    `,
  );

  const classes = useStyles();
  let drawer = (drawerToggle) => {
    return (
      <div>
        <div
          style={{ backgroundColor: COLORS.pushback, borderRight: 0 }}
          className={classes.toolbar}
        />
        <List className={classes.list}>
          {allMarkdownRemark.edges.map(({ node }) => {
            return (
              <ListItem
                className={classes.listItem}
                component={Link}
                key={node.id}
                to={node.frontmatter.path}
                button
                activeClassName={classes.selected}
                onClick={drawerToggle}
              >
                <ListItemText
                  className={classes.listText}
                  primary={node.frontmatter.title}
                />
              </ListItem>
            );
          })}
        </List>
      </div>
    );
  };

  return (
    <>
      <Hidden mdUp>
        <Drawer
          variant="temporary"
          anchor={'left'}
          open={open}
          onClose={drawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {drawer(drawerToggle)}
        </Drawer>
      </Hidden>
      <Hidden smDown>
        <Drawer
          variant="permanent"
          open
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          {drawer(null)}
        </Drawer>
      </Hidden>
      <Drawer
        variant="temporary"
        anchor={'left'}
        open={open}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
      />
    </>
  );
};

export default Sidebar;
